import { FileText, Loader2 } from "lucide-react";
import { Progress } from "@/shared/components/ui/progress";

interface ResumeParsingStepProps {
  parsingProgress: number;
  resumeName?: string;
}

export default function ResumeParsingStep({ parsingProgress, resumeName }: ResumeParsingStepProps) {
  return (
    <div className="flex min-h-[480px] items-center justify-center px-6 py-12">
      <div className="w-full max-w-md text-center">
        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-blue-50">
          <Loader2 className="h-10 w-10 animate-spin text-blue-600" />
        </div>
        <h2 className="mt-6 text-xl font-semibold text-gray-900">Reading Your Resume</h2>
        <p className="mt-2 text-sm leading-6 text-gray-500">
          We are extracting your profile, experience, education and skills. This will only take a few seconds.
        </p>
        <Progress value={parsingProgress} className="mt-7 h-2" />
        <p className="mt-3 text-sm font-medium text-blue-600">{parsingProgress}% completed</p>
        <div className="mt-7 rounded-xl border border-gray-200 bg-gray-50 p-4 text-left">
          <div className="flex items-center gap-3">
            <FileText className="h-5 w-5 shrink-0 text-gray-500" />
            <div className="min-w-0">
              <p className="truncate text-sm font-medium text-gray-800">{resumeName}</p>
              <p className="mt-1 text-xs text-gray-500">Securely processing your document</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}